<div *ngIf="showError" class="alert alert-warning">
  <span>{{errorMessage}}</span>
</div>
